import { createSelector } from 'reselect'

export const getCloserLocations = createSelector(
  (state) => state.geoObjects && state.geoObjects.closerLocations && state.geoObjects.closerLocations.elements
    ? state.geoObjects.closerLocations.elements
    : [],
  (closerLocations) => closerLocations
)
